import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "react-bootstrap";
import ManageListsForm from "./ManageListsForm";
import ProductTypesSrv from "../../../services/product_types_srv";

class ManageListWrapper extends React.Component {
    productTypesSrv;    

    constructor(props) {
        super(props);
        this.state = {                    
            isProductTypesLoaded: false,            
            products: [],
            productTypes: []            
        };

        this.getProductTypes = this.getProductTypes.bind(this);        
        this.productTypesSrv = new ProductTypesSrv(this.props.auth);
    }
   

    componentDidMount() {     
        this.getProductTypes();     
    }

    getProductTypes() {

        this.productTypesSrv.getAll()
            .then((res) => {
                    return res.json()
                }
            ) 
            .then((result) => {
                this.setState({
                    isProductTypesLoaded: true,
                    productTypes: result
                });
            },
                // Note: it's important to handle errors here
                // instead of a catch() block so that we don't swallow
                // exceptions from actual bugs in components.
                (error) => {
                    console.error(error);
                    this.setState({
                        isProductTypesLoaded: true,
                        productTypes: []
                    });                    
                }
            ).catch(function(reason) {
                console.error(reason);
                this.setState({
                    isProductTypesLoaded: true,
                    productTypes: []
                });                  
            });

    }

    render() {
        const {                        
            productTypes
            } = this.state;
       
        return (
            <Container>
                <Row>
                    <Col>
                        <ManageListsForm 
                            productTypes={productTypes}                                                  
                            auth={this.props.auth}
                        />
                    </Col>
                </Row>
                <hr />                
            </Container>
        );
    }

}

ManageListWrapper.propTypes = {
    auth: PropTypes.object
  };


export default ManageListWrapper;